import React from "react";

const ComingSoon = () => {
  return (
    <div className="coming-soon-page min-h-screen flex flex-col text-editorial-primary">
      <header className="shrink-0 pt-10 md:pt-14 px-6 text-center">
        <p className="text-xs md:text-sm font-medium tracking-[0.4em] uppercase text-editorial-primary">
          Edutopia
        </p>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-6 py-16 md:py-24">
        <div className="w-full max-w-2xl rounded-3xl border border-editorial-stroke bg-canvas/95 px-8 py-12 md:px-12 md:py-16 shadow-sm">
          <h1 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-editorial-accent">
            Great things coming soon.
          </h1>
        </div>
      </main>
    </div>
  );
};

export default ComingSoon;
